import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: `${config.appUrlPortal}${config.devAssetsFolder}/img/p4f-icon.svg`,
    loading: `${config.appUrlPortal}${config.devAssetsFolder}/img/p4f-loading.svg`,
    attempt: 2
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/lazyLoad.js